import { time } from 'pos-shared/utils/millisecondsHelper.ts';

export const standardCachingQueryOptions = {
  cacheTime: time.tenMinutesInMilliseconds,
  staleTime: time.oneMinuteInMilliseconds,
} as const;
